import throttle from 'lodash/throttle'
import refs from '../helpers/refs'

class CFooter {
  constructor (el) {
    this.footer = el
    this.$refs = refs(this.footer)
    this.menuHeights = {}
    this.init()
  }

  init () {
    this.computeMenuHeights()

    if (this.$refs.navItems) {
      this.$refs.navItems.forEach((item) => {
        item.addEventListener('click', (e) => {
          e.preventDefault()

          if (this.getBreakpoint() === 'mobile') {
            const menu = item.getAttribute('data-menu')
            this.toggleMenu(menu)
          }
        })
      })
    }

    window.addEventListener(
      'resize',
      throttle(this.handleWindowResize.bind(this), 100)
    )
  }

  getBreakpoint () {
    return window.innerWidth >= 1280 ? 'desktop' : 'mobile'
  }

  computeMenuHeights () {
    this.menuHeights = {}

    this.$refs.menus.forEach((menu) => {
      const name = menu.getAttribute('data-menu')

      this.menuHeights[name] = menu.scrollHeight
    })
  }

  getNavItem (name) {
    return this.$refs.navItems.find((item) => {
      return item.getAttribute('data-menu') === name
    })
  }

  toggleMenu (name) {
    this.$refs.menus.forEach((menu) => {
      const handle = menu.getAttribute('data-menu')

      if (name === handle) {
        if (menu.classList.contains('c-footer__menu-links--active')) {
          menu.style.height = '0px'
          menu.classList.remove('c-footer__menu-links--active')
          this.getNavItem(handle).classList.remove(
            'c-footer__menu-heading--active'
          )
        } else {
          menu.style.height = `${this.menuHeights[handle]}px`
          menu.classList.add('c-footer__menu-links--active')
          this.getNavItem(handle).classList.add(
            'c-footer__menu-heading--active'
          )
        }
      }
    })
  }

  closeAllMenus () {
    this.$refs.menus.forEach((menu) => {
      menu.style.height = '0px'
      menu.classList.remove('c-footer__menu-links--active')
    })

    if (this.$refs.navItems) {
      this.$refs.navItems.forEach((item) => {
        item.classList.remove('c-footer__menu-heading--active')
      })
    }
  }

  clearMenuStyles () {
    this.$refs.menus.forEach((menu) => {
      menu.style.height = null
    })
  }

  handleWindowResize () {
    if (this.getBreakpoint() === 'mobile') {
      this.closeAllMenus()
    } else {
      this.closeAllMenus()
      this.clearMenuStyles()
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-c-footer]').forEach(el => new CFooter(el))
})
